/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Keyword_Optimizer_Toast_Applied_BulkInputs */

const en_keyword_optimizer_toast_applied_bulk = /** @type {(inputs: Keyword_Optimizer_Toast_Applied_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} suggestions applied to your resume`)
};

const de_keyword_optimizer_toast_applied_bulk = /** @type {(inputs: Keyword_Optimizer_Toast_Applied_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Vorschläge auf deinen Lebenslauf angewendet`)
};

const fr_keyword_optimizer_toast_applied_bulk = /** @type {(inputs: Keyword_Optimizer_Toast_Applied_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} suggestions appliquées à votre CV`)
};

const es_keyword_optimizer_toast_applied_bulk = /** @type {(inputs: Keyword_Optimizer_Toast_Applied_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sugerencias aplicadas a tu CV`)
};

const it_keyword_optimizer_toast_applied_bulk = /** @type {(inputs: Keyword_Optimizer_Toast_Applied_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} suggerimenti applicati al tuo CV`)
};

const nl_keyword_optimizer_toast_applied_bulk = /** @type {(inputs: Keyword_Optimizer_Toast_Applied_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} suggesties toegepast op je CV`)
};

const pl_keyword_optimizer_toast_applied_bulk = /** @type {(inputs: Keyword_Optimizer_Toast_Applied_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zastosowano ${i?.count} sugestii w Twoim CV`)
};

const fi_keyword_optimizer_toast_applied_bulk = /** @type {(inputs: Keyword_Optimizer_Toast_Applied_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ehdotusta sovellettu ansioluetteloosi`)
};

const da_keyword_optimizer_toast_applied_bulk = /** @type {(inputs: Keyword_Optimizer_Toast_Applied_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} forslag anvendt på dit CV`)
};

const sv_keyword_optimizer_toast_applied_bulk = /** @type {(inputs: Keyword_Optimizer_Toast_Applied_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} förslag tillämpade på ditt CV`)
};

/**
* | output |
* | --- |
* | "{count} suggestions applied to your resume" |
*
* @param {Keyword_Optimizer_Toast_Applied_BulkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_toast_applied_bulk = /** @type {((inputs: Keyword_Optimizer_Toast_Applied_BulkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Toast_Applied_BulkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_toast_applied_bulk(inputs)
	if (locale === "fr") return fr_keyword_optimizer_toast_applied_bulk(inputs)
	if (locale === "es") return es_keyword_optimizer_toast_applied_bulk(inputs)
	if (locale === "it") return it_keyword_optimizer_toast_applied_bulk(inputs)
	if (locale === "nl") return nl_keyword_optimizer_toast_applied_bulk(inputs)
	if (locale === "pl") return pl_keyword_optimizer_toast_applied_bulk(inputs)
	if (locale === "fi") return fi_keyword_optimizer_toast_applied_bulk(inputs)
	if (locale === "da") return da_keyword_optimizer_toast_applied_bulk(inputs)
	if (locale === "sv") return sv_keyword_optimizer_toast_applied_bulk(inputs)
	return en_keyword_optimizer_toast_applied_bulk(inputs)
});